/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { MemberSearchListArticleResponse } from "./MemberSearchListArticleResponse";

export type MemberSearchListArticleResponseApiRespoonse = {
  data?: MemberSearchListArticleResponse;
  status?: MemberSearchListArticleResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace MemberSearchListArticleResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
